import * as React from "react";
import { OverlayContext } from "../managers/OverlayManager";

function useOverlay() {
  const { showOverlay, hideOverlay } = React.useContext(OverlayContext);

  return {
    showOverlay,
    hideOverlay
  };
}

export default useOverlay;
